// extracted by mini-css-extract-plugin
export default {"wrapper":"X2-z","play":"Y2-z"};